export var IconsManifest = [
  {
    "id": "mi",
    "name": "Mission Control Icons"
  }
]